/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `AED` - United Arab Emirates Dirham
* `AFN` - Afghan Afghani
* `ALL` - Albanian Lek
* `AMD` - Armenian Dram
* `AOA` - Angolan Kwanza
* `ARS` - Argentine Peso
* `AUD` - Australian Dollar
* `AWG` - Aruban Florin
* `AZN` - Azerbaijani Manat
* `BAM` - Bosnia-Herzegovina Convertible Mark
* `BBD` - Barbadian Dollar
* `BDT` - Bangladeshi Taka
* `BGN` - Bulgarian Lev
* `BHD` - Bahraini Dinar
* `BIF` - Burundian Franc
* `BMD` - Bermudan Dollar
* `BND` - Brunei Dollar
* `BOB` - Bolivian Boliviano
* `BRL` - Brazilian Real
* `BSD` - Bahamian Dollar
* `BTC` - Bitcoin
* `BTN` - Bhutanese Ngultrum
* `BWP` - Botswanan Pula
* `BYN` - Belarusian Ruble
* `BZD` - Belize Dollar
* `CAD` - Canadian Dollar
* `CDF` - Congolese Franc
* `CHF` - Swiss Franc
* `CLF` - Chilean Unit of Account (UF)
* `CLP` - Chilean Peso
* `CNH` - Chinese Yuan (Offshore)
* `CNY` - Chinese Yuan
* `COP` - Colombian Peso
* `CRC` - Costa Rican Colón
* `CUC` - Cuban Convertible Peso
* `CUP` - Cuban Peso
* `CVE` - Cape Verdean Escudo
* `CZK` - Czech Republic Koruna
* `DJF` - Djiboutian Franc
* `DKK` - Danish Krone
* `DOP` - Dominican Peso
* `DZD` - Algerian Dinar
* `EGP` - Egyptian Pound
* `ERN` - Eritrean Nakfa
* `ETB` - Ethiopian Birr
* `EUR` - Euro
* `FJD` - Fijian Dollar
* `FKP` - Falkland Islands Pound
* `GBP` - British Pound Sterling
* `GEL` - Georgian Lari
* `GGP` - Guernsey Pound
* `GHS` - Ghanaian Cedi
* `GIP` - Gibraltar Pound
* `GMD` - Gambian Dalasi
* `GNF` - Guinean Franc
* `GTQ` - Guatemalan Quetzal
* `GYD` - Guyanaese Dollar
* `HKD` - Hong Kong Dollar
* `HNL` - Honduran Lempira
* `HRK` - Croatian Kuna
* `HTG` - Haitian Gourde
* `HUF` - Hungarian Forint
* `IDR` - Indonesian Rupiah
* `ILS` - Israeli New Sheqel
* `IMP` - Manx Pound
* `INR` - Indian Rupee
* `IQD` - Iraqi Dinar
* `IRR` - Iranian Rial
* `ISK` - Icelandic Króna
* `JEP` - Jersey Pound
* `JMD` - Jamaican Dollar
* `JOD` - Jordanian Dinar
* `JPY` - Japanese Yen
* `KES` - Kenyan Shilling
* `KGS` - Kyrgystani Som
* `KHR` - Cambodian Riel
* `KMF` - Comorian Franc
* `KPW` - North Korean Won
* `KRW` - South Korean Won
* `KWD` - Kuwaiti Dinar
* `KYD` - Cayman Islands Dollar
* `KZT` - Kazakhstani Tenge
* `LAK` - Laotian Kip
* `LBP` - Lebanese Pound
* `LKR` - Sri Lankan Rupee
* `LRD` - Liberian Dollar
* `LSL` - Lesotho Loti
* `LYD` - Libyan Dinar
* `MAD` - Moroccan Dirham
* `MDL` - Moldovan Leu
* `MGA` - Malagasy Ariary
* `MKD` - Macedonian Denar
* `MMK` - Myanma Kyat
* `MNT` - Mongolian Tugrik
* `MOP` - Macanese Pataca
* `MRU` - Mauritanian Ouguiya
* `MUR` - Mauritian Rupee
* `MVR` - Maldivian Rufiyaa
* `MWK` - Malawian Kwacha
* `MXN` - Mexican Peso
* `MYR` - Malaysian Ringgit
* `MZN` - Mozambican Metical
* `NAD` - Namibian Dollar
* `NGN` - Nigerian Naira
* `NIO` - Nicaraguan Córdoba
* `NOK` - Norwegian Krone
* `NPR` - Nepalese Rupee
* `NZD` - New Zealand Dollar
* `OMR` - Omani Rial
* `PAB` - Panamanian Balboa
* `PEN` - Peruvian Nuevo Sol
* `PGK` - Papua New Guinean Kina
* `PHP` - Philippine Peso
* `PKR` - Pakistani Rupee
* `PLN` - Polish Zloty
* `PYG` - Paraguayan Guarani
* `QAR` - Qatari Rial
* `RON` - Romanian Leu
* `RSD` - Serbian Dinar
* `RUB` - Russian Ruble
* `RWF` - Rwandan Franc
* `SAR` - Saudi Riyal
* `SBD` - Solomon Islands Dollar
* `SCR` - Seychellois Rupee
* `SDG` - Sudanese Pound
* `SEK` - Swedish Krona
* `SGD` - Singapore Dollar
* `SHP` - Saint Helena Pound
* `SLE` - Sierra Leonean Leone
* `SOS` - Somali Shilling
* `SRD` - Surinamese Dollar
* `SSP` - South Sudanese Pound
* `STN` - São Tomé and Príncipe Dobra
* `SVC` - Salvadoran Colón
* `SYP` - Syrian Pound
* `SZL` - Swazi Lilangeni
* `THB` - Thai Baht
* `TJS` - Tajikistani Somoni
* `TMT` - Turkmenistani Manat
* `TND` - Tunisian Dinar
* `TOP` - Tongan Paʻanga
* `TRY` - Turkish Lira
* `TTD` - Trinidad and Tobago Dollar
* `TWD` - New Taiwan Dollar
* `TZS` - Tanzanian Shilling
* `UAH` - Ukrainian Hryvnia
* `UGX` - Ugandan Shilling
* `USD` - United States Dollar
* `UYU` - Uruguayan Peso
* `UZS` - Uzbekistan Som
* `VES` - Venezuelan Bolívar Soberano
* `VND` - Vietnamese Dong
* `VUV` - Vanuatu Vatu
* `WST` - Samoan Tala
* `XAF` - CFA Franc BEAC
* `XAG` - Silver (troy ounce)
* `XAU` - Gold (troy ounce)
* `XCD` - East Caribbean Dollar
* `XCG` - Caribbean Guilder
* `XDR` - Special Drawing Rights
* `XOF` - CFA Franc BCEAO
* `XPD` - Palladium Ounce
* `XPF` - CFP Franc
* `XPT` - Platinum Ounce
* `YER` - Yemeni Rial
* `ZAR` - South African Rand
* `ZMW` - Zambian Kwacha
* `ZWG` - Zimbabwean ZiG
 */
export type QualityCurrency = typeof QualityCurrency[keyof typeof QualityCurrency];


export const QualityCurrency = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTC: 'BTC',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLF: 'CLF',
  CLP: 'CLP',
  CNH: 'CNH',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GGP: 'GGP',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LYD: 'LYD',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRU: 'MRU',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SOS: 'SOS',
  SRD: 'SRD',
  SSP: 'SSP',
  STN: 'STN',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VES: 'VES',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XCD: 'XCD',
  XCG: 'XCG',
  XDR: 'XDR',
  XOF: 'XOF',
  XPD: 'XPD',
  XPF: 'XPF',
  XPT: 'XPT',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW',
  ZWG: 'ZWG',
} as const;
